// ============================================================================
// CORRECT ANSWERS - Index des réponses correctes pour tous les chapitres
// ============================================================================
// Structure: [chapterId][levelId][difficulty] = correctIndex
// Les indices commencent à 0

export const correctAnswers = {
  // CHAPITRE 1: GENÈSE (Niveaux 1-13)
  1: {
    1: { easy: 1, medium: 2, hard: 1 },
    2: { easy: 1, medium: 2, hard: 1 },
    3: { easy: 2, medium: 2, hard: 1 },
    4: { easy: 1, medium: 2, hard: 1 },
    5: { easy: 1, medium: 2, hard: 1 },
    6: { easy: 2, medium: 1, hard: 1 },
    7: { easy: 1, medium: 1, hard: 1 },
    8: { easy: 1, medium: 2, hard: 1 },
    9: { easy: 1, medium: 2, hard: 1 },
    10: { easy: 2, medium: 1, hard: 1 },
    11: { easy: 1, medium: 1, hard: 1 },
    12: { easy: 2, medium: 1, hard: 1 },
    13: { easy: 2, medium: 1, hard: 1 }
  },

  // CHAPITRE 2: EXODE (Niveaux 14-26)
  2: {
    14: { easy: 1, medium: 0, hard: 1 },
    15: { easy: 1, medium: 1, hard: 1 },
    16: { easy: 1, medium: 2, hard: 1 },
    17: { easy: 1, medium: 2, hard: 1 },
    18: { easy: 2, medium: 1, hard: 1 },
    19: { easy: 2, medium: 2, hard: 1 },
    20: { easy: 1, medium: 0, hard: 1 },
    21: { easy: 2, medium: 2, hard: 1 },
    22: { easy: 1, medium: 2, hard: 1 },
    23: { easy: 1, medium: 1, hard: 1 },
    24: { easy: 1, medium: 1, hard: 1 },
    25: { easy: 1, medium: 1, hard: 1 },
    26: { easy: 1, medium: 1, hard: 1 }
  },

  // CHAPITRE 3: JÉSUS-CHRIST (Niveaux 27-39)
  3: {
    27: { easy: 1, medium: 2, hard: 1 },
    28: { easy: 2, medium: 1, hard: 1 },
    29: { easy: 1, medium: 1, hard: 1 },
    30: { easy: 1, medium: 1, hard: 1 },
    31: { easy: 1, medium: 1, hard: 1 },
    32: { easy: 1, medium: 2, hard: 1 },
    33: { easy: 1, medium: 1, hard: 1 },
    34: { easy: 1, medium: 1, hard: 1 },
    35: { easy: 1, medium: 1, hard: 1 },
    36: { easy: 1, medium: 2, hard: 1 },
    37: { easy: 1, medium: 1, hard: 1 },
    38: { easy: 1, medium: 1, hard: 1 },
    39: { easy: 1, medium: 1, hard: 1 }
  },

  // CHAPITRE 4: CRUCIFIXION/RÉSURRECTION (Niveaux 40-52)
  4: {
    40: { easy: 1, medium: 2, hard: 2 },
    41: { easy: 2, medium: 2, hard: 1 },
    42: { easy: 1, medium: 0, hard: 1 },
    43: { easy: 1, medium: 1, hard: 1 },
    44: { easy: 1, medium: 1, hard: 2 },
    45: { easy: 1, medium: 1, hard: 1 },
    46: { easy: 1, medium: 2, hard: 1 },
    47: { easy: 1, medium: 1, hard: 1 },
    48: { easy: 1, medium: 1, hard: 1 },
    49: { easy: 2, medium: 1, hard: 1 },
    50: { easy: 2, medium: 2, hard: 1 },
    51: { easy: 1, medium: 2, hard: 1 },
    52: { easy: 1, medium: 1, hard: 2 }
  },

  // CHAPITRE 5: ÉGLISE PRIMITIVE (Niveaux 53-65)
  5: {
    53: { easy: 1, medium: 1, hard: 1 },
    54: { easy: 1, medium: 1, hard: 1 },
    55: { easy: 2, medium: 1, hard: 1 },
    56: { easy: 1, medium: 1, hard: 1 },
    57: { easy: 2, medium: 1, hard: 1 },
    58: { easy: 1, medium: 1, hard: 1 },
    59: { easy: 1, medium: 1, hard: 1 },
    60: { easy: 2, medium: 1, hard: 1 },
    61: { easy: 1, medium: 1, hard: 1 },
    62: { easy: 1, medium: 1, hard: 1 },
    63: { easy: 1, medium: 1, hard: 1 },
    64: { easy: 1, medium: 1, hard: 1 },
    65: { easy: 1, medium: 1, hard: 1 }
  },

  // CHAPITRE 6: MISSIONS DE PAUL (Niveaux 66-78)
  6: {
    66: { easy: 1, medium: 1, hard: 1 },
    67: { easy: 1, medium: 1, hard: 1 },
    68: { easy: 1, medium: 1, hard: 1 },
    69: { easy: 1, medium: 1, hard: 1 },
    70: { easy: 1, medium: 2, hard: 1 },
    71: { easy: 1, medium: 1, hard: 1 },
    72: { easy: 2, medium: 1, hard: 1 },
    73: { easy: 1, medium: 2, hard: 1 },
    74: { easy: 1, medium: 1, hard: 1 },
    75: { easy: 1, medium: 1, hard: 1 },
    76: { easy: 1, medium: 1, hard: 1 },
    77: { easy: 1, medium: 1, hard: 1 },
    78: { easy: 1, medium: 3, hard: 1 }
  },

  // CHAPITRE 7: LETTRES/APOCALYPSE (Niveaux 79-91)
  7: {
    79: { easy: 2, medium: 1, hard: 1 },
    80: { easy: 1, medium: 1, hard: 1 },
    81: { easy: 1, medium: 1, hard: 1 },
    82: { easy: 2, medium: 1, hard: 1 },
    83: { easy: 1, medium: 1, hard: 1 },
    84: { easy: 2, medium: 1, hard: 1 },
    85: { easy: 1, medium: 1, hard: 1 },
    86: { easy: 1, medium: 1, hard: 1 },
    87: { easy: 1, medium: 1, hard: 1 },
    88: { easy: 1, medium: 1, hard: 1 },
    89: { easy: 2, medium: 1, hard: 1 },
    90: { easy: 1, medium: 1, hard: 1 },
    91: { easy: 1, medium: 1, hard: 1 }
  },

  // CHAPITRE 8: BONUS (Niveaux 92-100)
  8: {
    92: { easy: 1, medium: 1, hard: 1 }
  }

};

/**
 * Obtenir la réponse correcte pour une question
 * @param {number} levelId - ID du niveau (1-100)
 * @param {string} difficulty - Difficulté ('easy', 'medium', 'hard')
 * @returns {number} Index de la réponse correcte (0-3)
 */
export const getCorrectAnswer = (levelId, difficulty) => {
  // Déterminer le chapitre
  let chapterId = 1;
  if (levelId >= 1 && levelId <= 13) chapterId = 1;
  else if (levelId >= 14 && levelId <= 26) chapterId = 2;
  else if (levelId >= 27 && levelId <= 39) chapterId = 3;
  else if (levelId >= 40 && levelId <= 52) chapterId = 4;
  else if (levelId >= 53 && levelId <= 65) chapterId = 5;
  else if (levelId >= 66 && levelId <= 78) chapterId = 6;
  else if (levelId >= 79 && levelId <= 91) chapterId = 7;
  else if (levelId >= 92 && levelId <= 100) chapterId = 8;
  
  const answer = correctAnswers[chapterId]?.[levelId]?.[difficulty];
  
  if (answer === undefined) {
    // console.warn(`⚠️ Réponse correcte non trouvée pour niveau ${levelId}, difficulté ${difficulty}`);
    return 0; // Fallback
  }
  
  return answer;
};

export default correctAnswers;
